/**
 * This file defines the route for client users of the application.
 * It sets up the layout for client routes, rendering an `Outlet` for nested routes.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_client')({
    component: Layout,
});

function Layout() {
    return <Outlet />;
}
